import { ResourceType, TypedResource } from '@alexandrainst/plana-react-api'

export type CachedResourceList<T extends ResourceType> = {
  type: T
  items: TypedResource<T>[]
  currentVersion: number
  sinceVersion: number
}

export const isCacheResourceList = <T extends ResourceType>(
  type: T,
  elm: CachedResourceList<T> | unknown
): elm is CachedResourceList<T> =>
  typeof elm === 'object' &&
  elm !== null &&
  Object.prototype.hasOwnProperty.call(elm, 'type') &&
  (elm as CachedResourceList<T>).type === type

export const detailsCacheUpdater =
  <T extends ResourceType>(newElm: TypedResource<T>) =>
  (oldElm: TypedResource<T> | undefined) =>
    oldElm === undefined || oldElm.data.version < newElm.data.version
      ? newElm
      : oldElm

export const getStatusCodeFromError = (error: unknown): number => {
  if (error instanceof Error) {
    const message = error.message
    const match = message.match(/\[(\d+)\]/)
    if (match && match[1]) {
      return parseInt(match[1], 10)
    }
  }
  return 0
}
